import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge12 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権はローンで購入できるか' fontWeight={700} />
                <p>
                    結論として、審査が必要ですがゴルフ会員権はローンで購入出来ます。
                    <br />
                    ゴルフ専用のローンが、様々な金融機関から提供されており、内容も低額コース向けのものから高額コース向けのもの、担保ローンや無担保ローン等、種類や金利も様々です。
                    <br />
                    ローンはゴルフ場やゴルフ会員権を扱う会社から紹介される場合もありますが、あくまで金融機関と契約する点は押さえておきましょう。
                    <br />
                    以下では、住地ゴルフで取り扱いがある金融機関のプランをご紹介します。
                </p>

                <Heading3 title='スルガ銀行' />
                <p>
                    申込資格：①年齢20歳以上65歳未満（ローン完済時70歳以下）
                    <br />
                    &emsp;&emsp;&emsp;&emsp;&emsp;②安定した収入がある方
                    <br />
                    資金使途：ゴルフ会員権購入に関わる費用全般、ゴルフクラブ・グッズ
                    <br />
                    融資金額：10万円～800万円
                    <br />
                    返済期間：6～120回（6ヶ月～10年）
                    <br />
                    金利&emsp;&emsp;：年2.5～5.0％（固定金利）
                    <br />
                    担保&emsp;&emsp;：無担保
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権をローンで購入した際の金利相場' fontWeight={700} />
                <p>
                    ローンの金利は、担保があるかないかで変わります。
                    <br />
                    担保ありのローンの例としては、かんそうしんのⅠ型・Ⅱ型があり、Ⅰ型の金利が年利４．０％、Ⅱ型の金利が年利５．０％です。
                    <br />
                    担保になるものはゴルフ会員権が主ではありますが、法人であれば株式や債券などを担保にすることもあります。
                    <br />
                    <br />
                    次に無担保ローンの金利をまとめると、以下のようになります。
                    <br />
                    <br />
                    ・スルガ銀行：年利２．５％～５．０％
                    <br />
                    ・かんそうしんⅢ型：年利５．８％
                    <br />
                    ・オリックス銀行：６．０％～９．８％
                    <br />
                    <br />
                    金融機関よってかなり幅があることがわかります。
                    <br />
                    申込人の職業やローン総額によって金利は変動するため、どの金融機関でローンを組むか慎重に調べましょう。
                    <br />
                    また、金利は変動型なのか固定型なのかはしっかりと確認し、変動型の場合はそのリスクも考慮した上で申込みを行いましょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権のローン支払い中に売却は可能か' fontWeight={700} />
                <p>
                    結論から言うと、ローンの支払い中であっても売却は可能です。
                    <br />
                    ただし、ローンの残債がある場合は、原則として売却時に一括返済が基本となっています。
                    <br />
                    売却代金をローンの返済に充てられますが、売却代金より残債が上回った場合は自己資金で準備することになります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ローンでのゴルフ会員権の購入・売却は住地ゴルフへ' fontWeight={700} />
                <p>
                    ゴルフ会員権はローンで購入することが出来ますが、相場変動により残債額が多く売却できないケースもしっかりと考慮したうえで契約しましょう。
                    <br />
                    ゴルフ会員権の売買についてご不明点がございましたら、まずは住地ゴルフにご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge12;
